import { IconEyeOff, IconEye } from '@tabler/icons-react';
import React from 'react';
import { cn } from 'src/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  hasError?: boolean;
  hasSuccess?: boolean;
  hasWarning?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, hasError, hasSuccess, hasWarning, ...props }, ref) => {
    const [inputType, setInputType] = React.useState(type);
    const isPassword = type === 'password';
    const togglePassword = () => {
      setInputType(inputType === 'password' ? '' : 'password');
    };

    return (
      <div className="relative flex items-center w-full text-foreground">
        <input
          type={inputType}
          className={cn(
            'peer rounded-md border border-input transition-all flex h-10 w-full shadow-sm text-foreground focus-within:text-foreground bg-background px-3.5 py-2.5 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:shadow-fc-secondary disabled:pointer-events-none disabled:bg-muted disabled:text-muted-foreground invalid:shadow-hv-error invalid:bg-background invalid:text-foreground',
            icon ? 'pl-11' : 'pl-3.5',
            isPassword ? 'pr-11' : 'pr-3.5',
            hasError && 'border-red-600',
            hasSuccess && '!shadow-hv-success',
            hasWarning && '!shadow-hv-warning',
            className,
          )}
          ref={ref}
          {...props}
        />
        {icon && (
          <span className="absolute left-3.5 text-muted-foreground peer-focus:text-foreground">
            {icon}
          </span>
        )}
        {isPassword && (
          <button
            type="button"
            className="absolute right-3.5 text-muted-foreground peer-focus:text-foreground"
            onClick={togglePassword}
          >
            {inputType ? <IconEyeOff /> : <IconEye />}
          </button>
        )}
      </div>
    );
  },
);

Input.displayName = 'Input';

export { Input };
